import styled from "styled-components";

import CrmEnrichmentJobBanner from "../../CrmEnrichmentJobBanner/CrmEnrichmentJobBanner";

export const StyledJobEditorInputWrapper = styled.div`
    max-width: 320px;
`;

export const StyledJobEditorBanner = styled(CrmEnrichmentJobBanner)`
    margin: -8px 0 0;
`;
